import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchGroupsRoutePathByLocale = {
  en: '/en/groups',
  es: '/es/grupos',
  pt: '/pt/grupos',
} satisfies Record<I18nLocale, string>;

export const searchGroupsRoutePaths = Object.values(
  searchGroupsRoutePathByLocale,
);

export const searchGroupsRoutePathsWithoutLang = Array.from(
  new Set(searchGroupsRoutePaths.map((path) => path.substring(3))),
);
